class DlTutorialVideos extends HTMLElement {
    constructor() {
        super();
        this.readMoreBtn = this.querySelector('.dl-tutorial-videos-container-button-active');
        this.ol = this.querySelector('.dl-tutorial-videos-container-ul');
    }

    connectedCallback() {
        this.init();
    }

    init() {
        this.toggleBtn();
        this.readMoreBtn?.addEventListener('click', this.handleReadMoreClick.bind(this));
        window.addEventListener('resize', this.resize.bind(this));
    }

    handleReadMoreClick() {
        if (!this.readMoreBtn.classList.contains('dl-for-hide')) {
            this.ol.querySelectorAll('li').forEach((li, index) => {
                li.classList.remove('dl-hide-pc');
                li.classList.remove('dl-hide-mobile');
            });
            this.readMoreBtn.classList.add('dl-for-hide');
        } else {
            this.ol.querySelectorAll('li').forEach((li, index) => {
                if (index >= 4) {
                    li.classList.add('dl-hide-mobile');
                }
                if (index >= 8) {
                    li.classList.add('dl-hide-pc');
                }
            });
            this.readMoreBtn.classList.remove('dl-for-hide');
        }
    }

    toggleBtn() {
        let lis = this.ol.querySelectorAll('li');
        if (window.innerWidth >= 990) {
            if (lis.length <= 8) {
                this.readMoreBtn.parentElement.classList.remove('dl-show');
            } else {
                this.readMoreBtn.parentElement.classList.add('dl-show');
            }
        } else {
            if (lis.length <= 4) {
                this.readMoreBtn.parentElement.classList.remove('dl-show');
            } else {
                this.readMoreBtn.parentElement.classList.add('dl-show');
            }
        }
    }

    resize() {
        if (this.resizing) {
            clearTimeout(this.resizing);
        }
        this.resizing = setTimeout(() => {
            this.toggleBtn();
            this.resizing = null;
        }, 200);
    }
}
customElements.define('dl-tutorial-videos', DlTutorialVideos);